import { combineReducers } from '@reduxjs/toolkit';
import { toArray } from 'lodash';

import { ROUTE_REPORTS, locationHash } from '@modules/shared';
import { resetOnLogoutReducer } from '@utils';

import {
  moduleName as basicReportsModuleName,
  reducers as basicReportsReducers,
} from '../basicReports';
import { OpenReportParamsModalAction } from '../common/types';
import { reportsTabs } from '../constants';
import { moduleName as customReportsModuleName } from '../customReports/duck/constants';
import { reducer as customReportsReducers } from '../customReports/duck/slice';
import {
  moduleName as historyReportsModuleName,
  reducers as historyReportsReducers,
} from '../historyReports';
import {
  CLOSE_REPORT_PARAMS_MODAL,
  OPEN_REPORT_PARAMS_MODAL,
  SET_ACTIVE_TAB,
} from './actions';

const validTabs = toArray(reportsTabs).filter(Boolean);
const defaultTab = locationHash.getValid(validTabs, reportsTabs.BASIC);

const activeTab = (
  state = defaultTab,
  {
    type,
    payload = {},
  }: {
    type: string;
    payload: string | { hash: string } | Record<string, never>;
  },
) => {
  switch (type) {
    case SET_ACTIVE_TAB: {
      return payload;
    }
    case ROUTE_REPORTS: {
      const { hash } = payload as { hash: string };
      return hash || state;
    }
    default: {
      return state;
    }
  }
};

const reportParamsVisible = (state = false, { type }: { type: string }) => {
  switch (type) {
    case OPEN_REPORT_PARAMS_MODAL: {
      return true;
    }
    case CLOSE_REPORT_PARAMS_MODAL: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const reportParamsDataInitialState: OpenReportParamsModalAction = {
  organizationGuid: null,
  users: [],
  reportType: null,
};

const reportParamsData = (
  state = reportParamsDataInitialState,
  { type, payload }: { type: string; payload: OpenReportParamsModalAction },
) => {
  switch (type) {
    case OPEN_REPORT_PARAMS_MODAL: {
      return payload;
    }
    case CLOSE_REPORT_PARAMS_MODAL: {
      return reportParamsDataInitialState;
    }
    default: {
      return state;
    }
  }
};

const reducer = combineReducers({
  reportParamsVisible,
  reportParamsData,
  activeTab,
  [historyReportsModuleName]: historyReportsReducers,
  [basicReportsModuleName]: basicReportsReducers,
  [customReportsModuleName]: customReportsReducers,
});

export default resetOnLogoutReducer(reducer);
